import { createSelector } from '@ngrx/store';

import { basketAccountsFeatureKey } from '../reducers/basket-accounts.reducer';
import { basketDataFeatureKey, State } from '../reducers/basket-data.reducer';
import { basketManualDiscountsFeatureKey } from '../reducers/basket-manual-discounts.reducer';
import { basketTrackingFeatureKey } from '../reducers/basket-tracking.reducer';
import {
  adapter as uiAdapter,
  basketUiFeatureKey,
} from '../reducers/basket-ui.reducer';
import * as fromBasket from '../store';
import { selectBasketState } from '../store';

export const selectBasketAccountsState = createSelector(
  selectBasketState,
  (state) => state[basketAccountsFeatureKey],
);
/**
 * state slice selector
 */
export const selectBasketDataState = createSelector<
  fromBasket.State,
  [fromBasket.BasketState],
  State
>(fromBasket.selectBasketState, (state) => state[basketDataFeatureKey]);

export const selectBasketUiState = createSelector(
  selectBasketState,
  (state) => state[basketUiFeatureKey],
);

export const selectBasketManualDiscountsState = createSelector(
  selectBasketState,
  (state) => state[basketManualDiscountsFeatureKey],
);

export const selectBasketTrackingState = createSelector(
  selectBasketState,
  (state) => state[basketTrackingFeatureKey],
);

export const { selectEntities: selectGroupedBasketEntities } =
  uiAdapter.getSelectors(selectBasketUiState);
